import {
  Button,
  Typography,
  Row,
  Col,
  Drawer,
  Table,
  message,
  Popconfirm,
  Space,
  Tag,
  Modal,
  Input,
} from "antd";
import { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import UserForm from "./form";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  DeleteDataOnServer,
  GetDataFromServer,
  GetDataListFromServer,
} from "../../lib/api";
import { AGENT_LIST, USER_DELETE, USER_GET_LIST } from "../../lib/config";
import { QUERY_USER } from "../../lib/query_obj";
import { moneyFormat, queryHandler } from "../../lib/global_functions";
import UserDetail from "./detail";
import DepositModal from "../transaction/depositModal";
import WithdrawModal from "../transaction/withdrawModal";
import { setState } from "../../redux/user";
import moment from "moment-timezone";
import dayjs from "dayjs";

const { Text } = Typography;
export default function User() {
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(false);
  const [detail, setDetail] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [detailForm, setDetailForm] = useState(false);

  const [depositModal, setShowDepositModal] = useState(false);
  const [depositData, setShowDepositData] = useState(false);

  const [withdrawModal, setShowWithdrawModal] = useState(false);
  const [withdrawData, setWithdrawData] = useState(false);

  const dispatch = useDispatch();

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const [filter, setFilter] = useState({
    code: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getRefreshDataList() {
    await GetDataFromServer(AGENT_LIST, user.access_token)
      .then((res) => {
        dispatch(
          setState({
            ...user,
            points: res.data.points,
            total_deposit_points: res.data.total_deposit_points,
            total_withdraw_points: res.data.total_withdraw_points,
          })
        );
      })
      .catch((error) => {
        toast.error(error?.response.data || "Connection Error");
      });
  }

  async function getDataList(page_number, per_page, updateFilter) {
    setLoading(true);
    await GetDataListFromServer(
      USER_GET_LIST,
      queryHandler(updateFilter ? updateFilter : filter, QUERY_USER, {
        page_number,
        per_page,
      }),
      user.access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        updateFilter && setFilter(updateFilter);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(res);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }


  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
    getRefreshDataList();
  }, []);

  const columns = [
    {
      title: "Nick Name",
      dataIndex: "nick_name",
    },
    {
      title: "Language",
      dataIndex: "language",
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Points",
      dataIndex: "wallet",
      render: (wallet) => moneyFormat(wallet?.points || 0),
    },
    {
      title: "Date Of Birth",
      dataIndex: "dob",
      render: (dob) => {
        return moment
          .utc(dob)
          .tz("Asia/Yangon")
          .format("DD-MM-YYYY");
      },
    },
    {
      title: "Is Locked",
      dataIndex: "is_locked",
      render: (is_locked) => {
        return (
          <Tag color={is_locked ? "lime" : "red"}>
            <Text style={{ color: is_locked ? "lime" : "red" }}>
              {is_locked ? "Yes" : "No"}
            </Text>
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "400px",
      render: (_, record) => (
        <Row justify="end">
          <Space>
            {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") && (
              <Button
                size={user.ui_size}
                onClick={() => depositHandler(record)}
                type="primary"
                icon={<PlusOutlined />}
              >
                Deposit
              </Button>
            )}
            {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") && (
              <Button
                size={user.ui_size}
                onClick={() => withdrawHandler(record)}
                type="primary"
                icon={<PlusOutlined />}
              >
                Withdraw
              </Button>
            )}

            <Button
              size={user.ui_size}
              type="primary"
              onClick={() => detailHandler(record)}
            >
              Detail
            </Button>

            {user.permissions.includes("AGENT_UPDATE_USER") && (
              <Button
                size={user.ui_size}
                type="primary"
                onClick={() => editHandler(record)}
              >
                Edit
              </Button>
            )}

            {user.permissions.includes("AGENT_DELETE_USER") && (
              <Popconfirm
                title="Are you sure to delete?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => deleteHandler(record.id)}
              >
                <Button size={user.ui_size} type="primary" danger>
                  Delete
                </Button>
              </Popconfirm>
            )}
          </Space>
        </Row>
      ),
    },
  ];

  const openDrawer = () => setShowForm(true);

  function depositHandler(record) {
    setShowDepositModal(true);
    setShowDepositData(record);
  }

  function withdrawHandler(record) {
    setShowWithdrawModal(true);
    setWithdrawData(record);
  }

  function editHandler(record) {
    setShowForm(true);
    setEdit(record);
  }
  function detailHandler(record) {
    setDetailForm(true);
    setDetail(record);
  }

  function closeDrawer(key) {
    setDetail(false);
    setEdit(false);
    setShowDepositData(false);
    setWithdrawData(false);
    setShowForm(false);
    setDetailForm(false);
    setShowDepositModal(false);
    setShowWithdrawModal(false);

    setEdit(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }

  async function deleteHandler(id) {
    setLoading(true);

    await DeleteDataOnServer(
      USER_DELETE,
      id,
      user.access_token,
      user.csrf_token
    )
      .then(() => {
        toast.success("Deleted user successfully");
        getDataList(pagin.page_number, pagin.per_page);
      })
      .catch(() => {
        message.error("Delete failed");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function clearFilter() {
    getDataList(pagin.page_number, pagin.per_page, {
      ...filter,
      code: "",
    });
  }

  return (
    <>
      <Row gutter={[16, 24]}>
        <Col span={24}>
          <Row justify="space-between">
            <Col>
              <Row align="middle">
                <Col>
                  <Text>User Code : &nbsp;</Text>
                </Col>
                <Col>
                  <Input
                    size={user.ui_size}
                    style={{ width: "150px" }}
                    value={filter.code}
                    placeholder="Search by Code"
                    onChange={(e) =>
                      setFilter({ ...filter, code: e.target.value })
                    }
                  />
                </Col>

                <Col style={{ marginLeft: "20px" }}>
                  <Space>
                    <Button
                      size={user.ui_size}
                      type="primary"
                      onClick={() => {
                        getDataList(pagin.page_number, pagin.per_page);
                      }}
                    >
                      Search
                    </Button>
                    <Button
                      size={user.ui_size}
                      type="primary"
                      onClick={() => clearFilter()}
                    >
                      Clear
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Col>
            <Col>
              {user.permissions.includes("AGENT_CREATE_USER") && (
                <Button
                  size={user.ui_size}
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={openDrawer}
                >
                  New User
                </Button>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table
            size={user.ui_size}
            loading={loading}
            columns={columns}
            dataSource={list}
            rowKey={(e) => e.id}
            pagination={{
              total: pagin.total,
              defaultCurrent: 1,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
            }}
          />
        </Col>
      </Row>
      <Drawer
        open={showForm}
        title={edit ? "Update User Form" : "Create User Form"}
        width={560}
        destroyOnClose
        onClose={() => closeDrawer()}
      >
        <UserForm closeDrawer={closeDrawer} edit={edit} />
      </Drawer>
      <Drawer
        open={detailForm}
        title="User Detail"
        width={1600}
        destroyOnClose
        styles={{
          body: { margin: 0, padding: 0 },
          header: { borderBottom: "0px" },
        }}
        onClose={() => closeDrawer()}
      >
        <UserDetail closeDrawer={closeDrawer} detail={detail} />
      </Drawer>
      <Modal
        footer={null}
        title={
          <Row
            justify="space-between"
            align="middle"
            style={{ margin: "25px 0px" }}
          >
            <Col>
              <Text style={{ fontSize: "15px", fontWeight: "bold" }}>
                Deposit Form
              </Text>
            </Col>
            <Col>
              <Text
                type="success"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                Agent Points: {moneyFormat(user.points)}
              </Text>
            </Col>
          </Row>
        }
        open={depositModal}
        width={650}
        styles={{
          header: {
            marginBottom: "20px",
          },
        }}
        onCancel={() => setShowDepositModal(false)}
        destroyOnClose
      >
        <DepositModal closeDrawer={closeDrawer} detail={depositData} />
      </Modal>

      <Modal
        footer={null}
        title={
          <Row
            justify="space-between"
            align="middle"
            style={{ margin: "25px 0px" }}
          >
            <Col>
              <Text style={{ fontSize: "15px", fontWeight: "bold" }}>
                Withdraw Form
              </Text>
            </Col>
            <Col>
              <Text
                type="success"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                User Points: {moneyFormat(withdrawData?.wallet?.points || 0)}
              </Text>
            </Col>
          </Row>
        }
        open={withdrawModal}
        width={650}
        styles={{
          header: {
            marginBottom: "20px",
          },
        }}
        onCancel={() => setShowWithdrawModal(false)}
        destroyOnClose
      >
        <WithdrawModal closeDrawer={closeDrawer} detail={withdrawData} />
      </Modal>
    </>
  );
}
